// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UAVariable } from './UAVariable';
import {
    UAVariableFromJSON,
    UAVariableFromJSONTyped,
    UAVariableToJSON,
    UAVariableToJSONTyped,
} from './UAVariable';
import type { UARange } from './UARange';
import {
    UARangeFromJSON,
    UARangeFromJSONTyped,
    UARangeToJSON,
    UARangeToJSONTyped,
} from './UARange';

/**
 * 
 * @export
 * @interface UAAnalogUnitRange
 */
export interface UAAnalogUnitRange {
    /**
     * precision of the value to display
     */
    valuePrecision?: number;
    /**
     * 
     */
    value?: UAVariable;
    /**
     * 
     */
    accessLevel?: Array<UAAnalogUnitRangeAccessLevelEnum>;
    /**
     * 
     */
    userAccessLevel?: Array<UAAnalogUnitRangeUserAccessLevelEnum>;
    /**
     * OPC UA standard attribute - true if history is being recorded for this variable
     */
    historizing?: boolean;
    /**
     * 
     */
    instrumentRange?: UARange;
    /**
     * 
     */
    euRange?: UARange;
    /**
     * unit of the physical quantity that is measured
     */
    engineeringUnits?: string;
    /**
     * Possible discrete values for MultiStateDiscrete and TwoStateDiscrete types
     */
    enumStrings?: Array<string>;
}


/**
 * @export
 */
export const UAAnalogUnitRangeAccessLevelEnum = {
    CurrentRead: 'currentRead',
    CurrentWrite: 'currentWrite',
    HistoryRead: 'historyRead',
    HistoryWrite: 'historyWrite',
    SemanticChange: 'semanticChange',
    StatusWrite: 'statusWrite',
    TimestampWrite: 'timestampWrite',
    Reserved: 'reserved'
} as const;
export type UAAnalogUnitRangeAccessLevelEnum = typeof UAAnalogUnitRangeAccessLevelEnum[keyof typeof UAAnalogUnitRangeAccessLevelEnum];

/**
 * @export
 */
export const UAAnalogUnitRangeUserAccessLevelEnum = {
    CurrentRead: 'currentRead',
    CurrentWrite: 'currentWrite',
    HistoryRead: 'historyRead',
    HistoryWrite: 'historyWrite',
    SemanticChange: 'semanticChange',
    StatusWrite: 'statusWrite',
    TimestampWrite: 'timestampWrite',
    Reserved: 'reserved'
} as const;
export type UAAnalogUnitRangeUserAccessLevelEnum = typeof UAAnalogUnitRangeUserAccessLevelEnum[keyof typeof UAAnalogUnitRangeUserAccessLevelEnum];


/**
 * Check if a given object implements the UAAnalogUnitRange interface.
 */
export function instanceOfUAAnalogUnitRange(value: object): value is UAAnalogUnitRange {
    return true;
}

export function UAAnalogUnitRangeFromJSON(json: any): UAAnalogUnitRange {
    return UAAnalogUnitRangeFromJSONTyped(json, false);
}

export function UAAnalogUnitRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAAnalogUnitRange {
    if (json == null) {
        return json;
    }
    return {
        
        'valuePrecision': json['valuePrecision'] == null ? undefined : json['valuePrecision'],
        'value': json['value'] == null ? undefined : UAVariableFromJSON(json['value']),
        'accessLevel': json['accessLevel'] == null ? undefined : json['accessLevel'],
        'userAccessLevel': json['userAccessLevel'] == null ? undefined : json['userAccessLevel'],
        'historizing': json['historizing'] == null ? undefined : json['historizing'],
        'instrumentRange': json['instrumentRange'] == null ? undefined : UARangeFromJSON(json['instrumentRange']),
        'euRange': json['euRange'] == null ? undefined : UARangeFromJSON(json['euRange']),
        'engineeringUnits': json['engineeringUnits'] == null ? undefined : json['engineeringUnits'],
        'enumStrings': json['enumStrings'] == null ? undefined : json['enumStrings'],
    };
}

export function UAAnalogUnitRangeToJSON(json: any): UAAnalogUnitRange {
    return UAAnalogUnitRangeToJSONTyped(json, false);
}

export function UAAnalogUnitRangeToJSONTyped(value?: UAAnalogUnitRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valuePrecision': value['valuePrecision'],
        'value': UAVariableToJSON(value['value']),
        'accessLevel': value['accessLevel'],
        'userAccessLevel': value['userAccessLevel'],
        'historizing': value['historizing'],
        'instrumentRange': UARangeToJSON(value['instrumentRange']),
        'euRange': UARangeToJSON(value['euRange']),
        'engineeringUnits': value['engineeringUnits'],
        'enumStrings': value['enumStrings'],
    };
}

